var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { datadogLogs } from "@datadog/browser-logs";
import React from "react";
var initialStage = {
    logger: {
        log: console.log,
        debug: console.debug,
        warn: console.warn,
        info: console.info,
        error: console.error,
    },
};
export var LoggerContext = React.createContext(initialStage);
export var LoggerProvider = function (_a) {
    var children = _a.children, _b = _a.env, env = _b === void 0 ? "local" : _b, _c = _a.ddClientToken, ddClientToken = _c === void 0 ? "" : _c, _d = _a.ddService, ddService = _d === void 0 ? "" : _d, configurations = _a.configurations, _e = _a.forceLogging, forceLogging = _e === void 0 ? false : _e;
    var logger = initialStage.logger;
    if ((env === "production" || forceLogging) && ddClientToken) {
        try {
            datadogLogs.init(__assign({ clientToken: ddClientToken, site: "datadoghq.com", service: ddService, env: env, forwardErrorsToLogs: true, sessionSampleRate: 100 }, (configurations || {})));
        }
        catch (error) {
            console.log(error);
        }
        var logFunction_1 = function (logLevel, arg1, meta) {
            try {
                if ((meta === null || meta === void 0 ? void 0 : meta.error) || (meta === null || meta === void 0 ? void 0 : meta.err) || (meta === null || meta === void 0 ? void 0 : meta.e)) {
                    var error = meta.error, err = meta.err, e = meta.e, errorMeta = __rest(meta, ["error", "err", "e"]);
                    var errorObj = error || err || e;
                    meta = __assign({ error: {
                            stack: errorObj.stack,
                            message: errorObj.message,
                            kind: errorObj.name,
                        } }, errorMeta);
                }
                switch (logLevel) {
                    case "log":
                        datadogLogs.logger.log(arg1, { meta: meta });
                        break;
                    case "debug":
                        datadogLogs.logger.debug(arg1, { meta: meta });
                        break;
                    case "warn":
                        datadogLogs.logger.warn(arg1, { meta: meta });
                        break;
                    case "info":
                        datadogLogs.logger.info(arg1, { meta: meta });
                        break;
                    case "error":
                        datadogLogs.logger.error(arg1, { meta: meta });
                        break;
                    default:
                        datadogLogs.logger.log(arg1, { meta: meta });
                }
            }
            catch (error) {
                console.log("Error while logging:", error, arg1, meta);
            }
        };
        logger = {
            log: function (arg1, meta) { return logFunction_1("log", arg1, meta); },
            debug: function (arg1, meta) { return logFunction_1("debug", arg1, meta); },
            warn: function (arg1, meta) { return logFunction_1("warn", arg1, meta); },
            info: function (arg1, meta) { return logFunction_1("info", arg1, meta); },
            error: function (message, meta) { return logFunction_1("error", message, meta); },
        };
    }
    return (React.createElement(LoggerContext.Provider, { value: { logger: logger } }, children));
};
